import React, { useEffect, useState } from "react";
//import Iframe from 'react-iframe'
import axios from "axios";
import { env as environment } from "./actions/environment";

// Text between the first "<" and the next ">" (non-empty), same as
// /<([^>]+)>/ but scanned with indexOf so input with many "<" and no ">"
// cannot backtrack quadratically.
const bracketedPath = (url) => {
  let start = url.indexOf("<");
  while (start !== -1) {
    const end = url.indexOf(">", start + 1);
    if (end === -1) return null;
    if (end > start + 1) return url.slice(start + 1, end);
    start = url.indexOf("<", end + 1);
  }
  return null;
};

const IframePage = (props) => {
  const [apiResponse, setApiResponse] = useState(null);
  const [params, setParams] = useState(null);
  // console.log(apiResponse,"apiResponse")
  // const navigate = useNavigate();

  console.log(props.parsed,"iframe js ");
  const [ifmpage, setIfmpage] = useState({
    page: false,
    redirectLink: "",
    opacity: true,
  });

  useEffect(() => {
    getiframeLink();
  }, []);
  

  const redirectToCorrectURL = () => {
    const redirectURL = sessionStorage.getItem("redirectURL");
  
    if (redirectURL) {
      const additionalPath = bracketedPath(redirectURL);

      if (additionalPath) {
        const newRedirectURL = `https://www.google.com/${additionalPath}`;
        console.log("Redirecting to:", newRedirectURL);
        window.location.replace(newRedirectURL);
      } else {
        console.log("Redirecting to:", redirectURL);
        window.location.replace(redirectURL);
      }
  
      sessionStorage.removeItem("redirectURL");
    }
  };

  console.log(apiResponse,"apiResponse 5555555 ")
  useEffect(() => {
    const urlSearchString = window.location.search;
    console.log(urlSearchString,"urlSearchString")
   
    setParams(urlSearchString)
    
     }, []);

  console.log(params,"params2222")
   
  useEffect(() => {
    window.addEventListener("message", iframeEventListner);
    return () => {
      window.removeEventListener("message", iframeEventListner);
    };
  }, []); //eslint-disable-line



    const fetchLastClick = async (sessionId) => {
      console.log(sessionId,"fetchlastlink")
      try {

        // API endpoint
        // const apiUrl = "https://stage2.diro.live/Zuul-1.0/User-2.0/getlastclickedlink";

        // Payload data
        const payload = {
          sessionid: sessionId,
        };

        // Making the POST request using Axios
        const response = await axios.post(environment.get_lastclicked_link, payload);

        // Store the response in the state variable
        setApiResponse(response.data);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    useEffect(() => {
      if(apiResponse !== null && apiResponse !== undefined) {
        console.log("set redirect url in session storage",apiResponse)
        sessionStorage.setItem("redirectURL", apiResponse.data.redirecturl);
      }
    }, [apiResponse])

  // === EventListener function ===
  const iframeEventListner = async (event) => {
    console.log("11111111", event?.data);
    const sessionId = event?.data?.sessionid;
    if(sessionId !== undefined && sessionId !== null){
      fetchLastClick(sessionId);
    }
    // const buttonId = event?.data?.buttonid;

    // === Event when Exit button is clicked ===`
    if (event.data === "Terminate session from guac") {
      console.log("Terminate session storge",sessionStorage.getItem("redirectURL"))
      redirectToCorrectURL()
      window.removeEventListener("message", iframeEventListner);
    }
    // === Event when document is submitted successfully ===
    if(event?.data?.progress_status === "Submitted"){
      console.log("submitted session storge",sessionStorage.getItem("redirectURL"))
      redirectToCorrectURL()
      window.removeEventListener("message", iframeEventListner);
    }
    // if (event?.data?.progress_status === "Submitted" && !statusUpdated) {
    //   if (event?.data?.category === "address") {
    //     sessionStorage.setItem("submitStatus", "address");
    //   }
    //   if (event?.data?.buttonid === environment.staticBankOnlyButtonId) {
    //     sessionStorage.setItem("submitStatus", "bank");
    //   }
    //   if (event?.data?.buttonid === environment.staticBankFullButtonId) {
    //     sessionStorage.setItem("submitStatus", "bankfull");
    //   }

      // window.removeEventListener("message", iframeEventListner);
      // setTimeout(() => {
      //   navigate("/");
      // }, 6000);

    //   setStatusUpdated(true);
    // }
  };


  // console.log(parsed, "Parsed place");
  // console.log(parsed.trackid);

  // if(ifmpage.opacity) {

  // }
  function getiframeLink() {
    console.log("getiframeLink Hit ===================");

    // window.location.replace(res.data.verificationlink);
    setIfmpage((prev) => ({
      ...prev,
      page: true,
      redirectLink: environment.frontendurl + window.location.search,
    }));
    setTimeout(function () {
      setIfmpage((prev) => ({ ...prev, opacity: false }));
    }, 500);
  }

  return (
    <div className={"row if_wrap"}>
      {/* {ifmpage.page && ifmpage.redirectLink && <>
          {/* <iframe src={ifmpage.redirectLink} className={ifmpage.opacity ? "iframeWrap ifr_opacity":"iframeWrap"}></iframe> */}
      {/* <Iframe url={ifmpage.redirectLink} className={ifmpage.opacity ? "iframeWrap ifr_opacity":"iframeWrap"} /> 
        </> */}
      {ifmpage.page && ifmpage.redirectLink && (
        <React.Fragment>
          {console.log(ifmpage.page, ifmpage.redirectLink)}

          <iframe
            id="nocodemyframe"
            title="Diro nocode url"
            src={ifmpage.redirectLink}
            className={
              ifmpage.opacity ? "iframeWrap ifr_opacity" : "iframeWrap"
            }
            allow="clipboard-read *; clipboard-write *"
          ></iframe>
        </React.Fragment>
      )}
      <div className="App">
        <div className="loader_wrapper">
          <div className="dots-container">
            <div className="dot"></div>
            <div className="dot"></div>
            <div className="dot"></div>
          </div>
          <p className="wait-text">Please wait</p>
        </div>
      </div>
    </div>
  );
};

export default IframePage;
